import { render, staticRenderFns } from "./VRPlaceholder.vue?vue&type=template&id=2b2d8f9d"
import script from "./VRPlaceholder.vue?vue&type=script&lang=js"
export * from "./VRPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports